import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DetailText = styled.span<React.CSSProperties>`
  color: ${Colors['text']};
  display: -webkit-box;
  font-family: ${Fonts['light']};
  font-size: ${32 * Screen.widthRatio}px;
  line-height: ${40 * Screen.widthRatio}px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

export default DetailText;
